import firebase from "../../firebase";

export function countUnreadMessages(conversations, userKey) {
    if (!userKey) {
        return 0;
    }

    return conversations.reduce((count, conversation) => {
        if (
            conversation.deleted ||
            !conversation.participants.some(
                (participant) => participant.key === userKey,
            )
        ) {
            return count;
        }

        return (
            count +
            (conversation.messages || []).filter(
                (message) =>
                    !message.deleted &&
                    message.user !== userKey &&
                    !(message.readBy || []).includes(userKey),
            ).length
        );
    }, 0);
}

export function buildReadReceiptUpdates(
    conversation,
    userKey,
    pendingReceipts,
) {
    if (!conversation?.key || !userKey) {
        return {};
    }

    return (conversation.messages || []).reduce((updates, message) => {
        const pendingKey = `${conversation.key}/${message.key}`;
        const hasBeenRead = (message.readBy || []).includes(userKey);

        if (
            !message.deleted &&
            !hasBeenRead &&
            !pendingReceipts.has(pendingKey)
        ) {
            pendingReceipts.add(pendingKey);
            updates[`messages/${message.key}/readBy/${userKey}`] = true;
        }

        return updates;
    }, {});
}

export function markConversationRead(
    conversation,
    userKey,
    pendingReceipts,
) {
    const updates = buildReadReceiptUpdates(
        conversation,
        userKey,
        pendingReceipts,
    );
    const updatePaths = Object.keys(updates);

    if (updatePaths.length === 0) {
        return Promise.resolve(false);
    }

    return firebase
        .database()
        .ref("conversations")
        .child(conversation.key)
        .update(updates)
        .then(() => true)
        .catch((error) => {
            updatePaths.forEach((path) => {
                const messageKey = path.split("/")[1];
                pendingReceipts.delete(`${conversation.key}/${messageKey}`);
            });
            throw error;
        });
}
